module.exports = __webpack_public_path__ + "img/wr_5.dbf32ec1.png";